import { ref } from 'vue'
import type { CockpitLeaderboardEntry, TimeRange } from '@/types/cockpit'
import { fetchCockpitLeaderboard } from '@/api/cockpit'

export function useCockpitLeaderboard() {
  const entries = ref<CockpitLeaderboardEntry[] | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)

  async function fetch(range: TimeRange, limit?: number): Promise<void> {
    loading.value = true
    error.value = null
    try {
      entries.value = await fetchCockpitLeaderboard(range, limit)
    } catch {
      error.value = 'admin.cockpit.leaderboard.error'
    } finally {
      loading.value = false
    }
  }

  return { entries, loading, error, fetch }
}
